import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'components'
import AddressIcon from 'components/icons/AddressIcon'

const Location = ({ text, classNames }) => (
  <Badge
    text={text || 'Global'}
    classNames={classNames}
    icon={<AddressIcon className="w-3 text-white" />}
  />
)

Location.propTypes = {
  text: PropTypes.string,
  classNames: PropTypes.shape({
    text: PropTypes.string,
  }),
}

Location.defaultProps = {
  classNames: {},
}

export default Location
